module.exports = __webpack_public_path__ + "static/media/trump1.80a4f6b8.jpg";